/**
 * Syncs store review count across PDP social proof and reviews hero.
 * Uses the same filtered total as relic-reviews-page.js (published reviews
 * from the app proxy), not the Judge.me shop metafield.
 */

(function () {
  const CACHE_VERSION = 6;
  const CACHE_KEY_PREFIX = "relic-reviews:all:";
  const COUNT_SELECTOR = "[data-store-review-count]";

  function getCacheKey() {
    const shop = window.Shopify?.shop || window.location.hostname;
    return CACHE_KEY_PREFIX + shop;
  }

  function readCachedTotal() {
    try {
      const raw = sessionStorage.getItem(getCacheKey());
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (parsed?.version !== CACHE_VERSION) return null;

      if (typeof parsed.total === "number") return parsed.total;
      if (Array.isArray(parsed.reviews)) return parsed.reviews.length;

      return null;
    } catch {
      return null;
    }
  }

  function updateCountElements(count) {
    const els = document.querySelectorAll(COUNT_SELECTOR);
    for (const el of els) {
      el.textContent = String(count);
    }
  }

  async function fetchStoreReviewCount() {
    const url = new URL(
      "/apps/relic-modern-reviews-proxy/reviews",
      window.location.origin,
    );
    url.searchParams.set("count_only", "1");

    const response = await fetch(url.toString());
    if (!response.ok) return null;

    const data = await response.json();
    return typeof data.total === "number" ? data.total : null;
  }

  async function syncStoreReviewCount() {
    if (!document.querySelector(COUNT_SELECTOR)) return;

    const cachedTotal = readCachedTotal();
    if (cachedTotal !== null) {
      updateCountElements(cachedTotal);
      return;
    }

    const total = await fetchStoreReviewCount();
    if (total !== null) {
      updateCountElements(total);
    }
  }

  window.RelicStoreReviewCount = {
    CACHE_VERSION,
    CACHE_KEY_PREFIX,
    update: updateCountElements,
    sync: syncStoreReviewCount,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncStoreReviewCount, {
      once: true,
    });
  } else {
    syncStoreReviewCount();
  }
})();
